import _ from 'lodash';

export default function toCamelCase(inputData) {
  const outputData = {};
  _.forEach(inputData, (value, key) => {
    const camelCase = _.camelCase(key);
    outputData[camelCase] = value;
  });
  return outputData;
}
